module.exports = __webpack_public_path__ + "static/media/bundle-delete.18f592c3.svg";